import "../../index47.css";
import { jsxs as p, jsx as s } from "react/jsx-runtime";
import { a as n } from "../../type-BFTbooL7.js";
import { _ as f } from "../../cs-piwRuCFZ.js";
import v from "../NumberOutput/index.js";
const x = "_progress-wrapper_x340w_1", h = "_title_x340w_7", w = "_total_x340w_11", N = "_progress_x340w_1", e = {
  progressWrapper: x,
  title: h,
  total: w,
  progress: N
};
function P(d) {
  const {
    className: m,
    title: t,
    description: o,
    totalValue: a,
    value: l,
    showPercentageInTitle: i,
    children: u,
    color: _ = "var(--go-ui-color-primary-red)"
  } = d, g = n(l) ? l : 0, c = n(a) ? a : 0;
  let r;
  return c === 0 ? r = 0 : r = g / c * 100, /* @__PURE__ */ p("div", { className: f(e.progressWrapper, m), children: [
    (t || i) && /* @__PURE__ */ p("div", { className: e.title, children: [
      t,
      i && /* @__PURE__ */ s(
        v,
        {
          value: r,
          suffix: "%"
        }
      )
    ] }),
    /* @__PURE__ */ s("div", { className: e.total, children: /* @__PURE__ */ s(
      "div",
      {
        className: e.progress,
        style: {
          width: `${r}%`,
          backgroundColor: _
        }
      }
    ) }),
    o && /* @__PURE__ */ s("div", { className: e.description, children: o }),
    u
  ] });
}
export {
  P as default
};
